import React, { createContext, useContext, useState, useCallback, useMemo, ReactNode } from 'react';

/**
 * Contexto del módulo WPBOT: guarda el bot seleccionado en el selector
 * compartido para que las vistas (tools, contactos, conversaciones)
 * trabajen siempre sobre el mismo bot al navegar entre ellas.
 */
type TBotAdminContext = {
  selectedBotId: string,
}
const initialState:TBotAdminContext =  {
  selectedBotId: '',
}
interface BotAdminContextType {
  botAdmin: TBotAdminContext;
  updateBotAdmin: (newConfig: Partial<TBotAdminContext>) => void;
}
interface BotAdminProviderProps {
  children: ReactNode;
}

const BotAdminContext = createContext<BotAdminContextType>({botAdmin:initialState,updateBotAdmin:()=>{}});

export const BotAdminProvider:React.FC<BotAdminProviderProps> = ({ children }) => {
  const [botAdmin, setBotAdmin] = useState(initialState);
  const updateBotAdmin = useCallback((newConfig:Partial<TBotAdminContext>) => {
    setBotAdmin((prevConfig) => ({ ...prevConfig, ...newConfig }));
  }, []);
  
  const contextValue = useMemo(() => ({
    botAdmin,
    updateBotAdmin,
  }), [botAdmin, updateBotAdmin]);

  return (
    <BotAdminContext.Provider value={contextValue}>
      {children}
    </BotAdminContext.Provider>
  );
};

export const useBotAdmin = () => {
  return useContext(BotAdminContext);
};
